import React from 'react'
import SVG from 'react-svg-inline'

const NextGeneration = () =>
  <div>
    <section className="container full">
      <div className="col-12-of-12">
        {<img src={require('img/next-generation/paolo-mantini.jpg')} alt="JOMO Feature" />}
      </div>
    </section>
    <section className="container">
      <div className="client-quote">
        <blockquote>
          “A sublime piece of music, completely composed with the piano, a soundtrack for our life
          and a message: taking all the new generations across the globe closer to the art of Music. <br/>
          No schemes, prejudices, genre classifications, labels… <br/>
          <b className="brand-color">Just Music !</b>"
        </blockquote>
      </div>
    </section>
    <section className="container full">
      <div className="col-12-of-12">
        <iframe  src="https://www.youtube.com/embed/2Ks7irMarRI?controls=0&rel=0" frameBorder="0" allowFullScreen></iframe>
      </div>
    </section>
    <section className="container full split-view m-tb-m">
      <aside className="content">
        <h3>The Remix</h3>
        <h4 style={{ marginBottom: "20px"}}>
          Who better than the French genius producer Pépé Bradock could remix this song? <br/>
          He is a widely respected producer known for his versatile, singular and mesmerizing style and his 
          releases on labels such a Avatisme, Classic and Versatile Recordings. <br/>
          Bradock produces a trippy remix, dub version and reprise, using the piano melody in a completely original way. 
        </h4>
        <a href="https://www.beatport.com/release/next-generation/2073349" target="_blank" rel="noopener noreferrer" className="btn dark">View on Beatport</a>
      </aside>
      <aside>
      <iframe src="https://open.spotify.com/embed/track/3ZDg0iW5akbqcaHCaJN0dQ" width="100%" height="380" frameBorder="0" allowTransparency="true"></iframe>
      </aside>
    </section>
    <section className="container">
      <div className="client-quote text-center">
        <blockquote style={{marginBottom: "30px"}}>
          "Due linee di pianoforte immerse in un pathos dance raccontano il percorso della nuova generazione che avanza: Next Generation è un inno alla vita. Attraverso la semplicità del suono l'anima traccia il proprio cammino, cullata da un dolce movimento malinconico che diventa la colonna sonora della vita. La colonna sonora che avanza contro le avversità. Dedicato a mio zio Beppe."
        </blockquote>
        <a href="https://www.redbull.com/it-it/paolo-mantini-premiere-next-generation" target="_blank" rel="noopener noreferrer" className="btn dark">View Full article on Redbull</a>
      </div>
    </section>
  </div>

export default NextGeneration



// WEBPACK FOOTER //
// src/javascripts/clients/NextGeneration.js